export const companies_with_router = [35,3023,2415,5232, 934, 3765, 5490];

export const companies_with_tools = [35, 3023,2415,5232,934,5629, 5490];
